export const envGetOrThrow = (key, defaultValue)=>{
    const value = process.env[key] || defaultValue;
    if (!value) throw new Error("Environment variable ".concat(key, " not found."));
    return value;
};
